var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6B37450C-7B8D-4C9B-8FEE-2F3A56B0700D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guidemark-Admin-Desktop-Schedule-time-view-drag",
    transform: "translate(-656.000000, -80.000000)",
    fill: "#5A87EF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action-button-/-Primary-Copy",
    transform: "translate(656.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Icons-/-Edit-/-Light-gray-Copy",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-(6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3598928,0 L0.639376218,0 C0.294834308,0 0.0155945419,0.279239766 0.0155945419,0.623781676 C0.0155945419,2.36086743 0.760233918,4.01924953 2.05860136,5.17336745 L4.79044834,7.60148635 C5.26413255,8.02253898 5.53581873,8.62755849 5.53581873,9.26145223 L5.53581873,15.3442982 C5.53581873,15.8413743 6.09137428,16.1393762 6.50548245,15.8631823 L10.1856725,13.4098441 C10.3591618,13.2941033 10.4634503,13.0994152 10.4634503,12.8908382 L10.4634503,9.26145223 C10.4634503,8.62755849 10.7351364,8.02253898 11.2088206,7.60148635 L13.9405458,5.17336745 C15.2389132,4.01924953 15.9835526,2.36086743 15.9835526,0.623781676 C15.9835526,0.279239766 15.7043129,0 15.3598928,0 Z M13.1117203,4.24086257 L10.3799951,6.66910331 C9.64022905,7.32675437 9.21588694,8.27156432 9.21588694,9.2613304 L9.21588694,12.5570175 L6.78326023,14.1787281 L6.78326023,9.26145223 C6.78326023,8.27156432 6.35891811,7.32675437 5.61915203,6.66910331 L2.8874269,4.24098439 C2.01193956,3.46259746 1.45309455,2.39607701 1.30348441,1.24744153 L14.6956628,1.24744153 C14.5460526,2.39607701 13.9873294,3.46259746 13.1117203,4.24086257 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.23cac361fb7534fee165e284d0fa907c.svg";
export { ForwardRef as ReactComponent };